import React, { useEffect, useState } from "react";
import { Button, DatePicker } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import VoyageDetails from "../../../../components/VoyageDetails";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { useNavigate } from "react-router-dom";
import useUserData from "../../../../hooks/useUserData";

function AddFuelChangeover() {
  const navigate = useNavigate();
  const user = useUserData();
  const designation = user?.data?.designation;
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [form, setForm] = useState({
    changeOverCompletion: null,
    shipPositionCompletion: "",
    lowSulphurQtyAfter: "",
    ecaEntry: null,
    ecaExit: null,
    changeOverToHighSulphur: null,
    shipPositionHighSulphur: "",
    lowSulphurQtyBefore: "",
    remarks: "",
    chiefEngSign: "",
  });
  const [errors, setErrors] = useState({});
  const [loader, set_loader] = useState(false);

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    try {
      if (staff_dashboards) {
        const parsedData = JSON.parse(staff_dashboards);
        set_staff_dashboard(parsedData);
      }
    } catch (err) {
      console.error("Error parsing staff_dashboard:", err);
    }
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const SEND_NOTIFICATION_MASTER = async (record_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      FORM_DATA.append("record_id", record_id);
      FORM_DATA.append(
        "description",
        "A new sulphur fuel changeover record has been created. Please review and confirm it at your earliest convenience"
      );
      const response = await post(ApiURL?.sulphur_fcr_requests_notification_st, FORM_DATA);
      if (response?.status === true) {
        SuccessToast("Congratulations!", response?.message || "No message returned.");
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
    } catch (error) {
      ErrorToast("Request Failed", "Could not complete the request. Please try again.");
    }
  };

  const handleSubmit = () => {
     let newErrors = {};

  if (!form.changeOverCompletion) {
    newErrors.changeOverCompletion = "This field is required";
  }

  if (!form.ecaEntry) {
    newErrors.ecaEntry = "This field is required";
  }

  if (!form.ecaExit) {
    newErrors.ecaExit = "This field is required";
  }

  if (!form.changeOverToHighSulphur) {
    newErrors.changeOverToHighSulphur = "This field is required";
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return; // 🚫 STOP API CALL HERE
  }
    set_loader(true);
    try {
      const voyageId = staff_dashboard?.voyage_details?.[0]?.id;
      if (!voyageId) {
        ErrorToast("Error", "Voyage details missing. Please refresh and try again.");
        set_loader(false);
        return;
      }

      console.log("Submitting Fuel Changeover form:", form);
      const formData = new FormData();
      formData.append("voyage_id", String(voyageId));
      
      // const completionDate = form.changeOverCompletion && moment.isMoment(form.changeOverCompletion)
      //   ? form.changeOverCompletion.format("YYYY-MM-DD HH:mm:ss")
      //   : "";
      const completionDate = form.changeOverCompletion
  ? form.changeOverCompletion.format("YYYY-MM-DD HH:mm:ss")
  : "";
      formData.append("date_and_time_completion", completionDate);
      
      formData.append("ship_position", String(form.shipPositionCompletion || ""));
      formData.append("low_sulphur_quality_completion", String(form.lowSulphurQtyAfter || ""));
      
      // const ecaEntryDate = form.ecaEntry && moment.isMoment(form.ecaEntry)
      //   ? form.ecaEntry.format("YYYY-MM-DD HH:mm:ss")
      //   : "";
      const ecaEntryDate = form.ecaEntry
  ? form.ecaEntry.format("YYYY-MM-DD HH:mm:ss")
  : "";
      formData.append("date_and_time_entry_eca", ecaEntryDate);
      
      // const ecaExitDate = form.ecaExit && moment.isMoment(form.ecaExit)
      //   ? form.ecaExit.format("YYYY-MM-DD HH:mm:ss")
      //   : "";
      const ecaExitDate = form.ecaExit
  ? form.ecaExit.format("YYYY-MM-DD HH:mm:ss")
  : "";
      formData.append("date_and_time_exit_eca", ecaExitDate);
      
      // const changeoverDate = form.changeOverToHighSulphur && moment.isMoment(form.changeOverToHighSulphur)
      //   ? form.changeOverToHighSulphur.format("YYYY-MM-DD HH:mm:ss")
      //   : "";
      const changeoverDate = form.changeOverToHighSulphur
  ? form.changeOverToHighSulphur.format("YYYY-MM-DD HH:mm:ss")
  : null;
      formData.append("date_and_time_changeover_high_sulphur", changeoverDate);
      
      formData.append("ship_position_high_sulphur", String(form.shipPositionHighSulphur || ""));
      formData.append("low_sulphur_quality_start", String(form.lowSulphurQtyBefore || ""));
      formData.append("chief_eng_name_sign", String(form.chiefEngSign || ""));
      formData.append("remarks", String(form.remarks || ""));

      console.log("FormData being sent:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      post(ApiURL?.add_bunker_fuel_chargerover_st_fcr, formData)
        .then((res) => {
          const responseData = res?.response?.data || res;
          if (responseData?.status === true) {
            SuccessToast("Success message!", "Fuel changeover record added successfully");
            navigate("/list-fuel-changeover");
            if (designation && designation !== "Chief Engineer") {
              SEND_NOTIFICATION_MASTER(responseData?.id);
            }
            set_loader(false);
          } else {
            let newErrors = responseData?.errors || {};
            // Direct error mapping
            if (responseData?.error && typeof responseData.error === "string") {
              const err = responseData.error.toLowerCase();
              if (err.includes("date_and_time_completion")) newErrors.changeOverCompletion = responseData.error;
              if (err.includes("date_and_time_entry_eca")) newErrors.ecaEntry = responseData.error;
              if (err.includes("date_and_time_exit_eca")) newErrors.ecaExit = responseData.error;
              if (err.includes("date_and_time_changeover_high_sulphur")) newErrors.changeOverToHighSulphur = responseData.error;
            }
            setErrors(newErrors);
            if (Object.keys(newErrors).length === 0) {
              ErrorToast("Error", responseData?.message || responseData?.error || "Check your details.");
            }
            set_loader(false);
          }
        })
        .catch((error) => {
          set_loader(false);
          ErrorToast("Error", "Server side error occurred.");
          console.error("Error while submitting fuel changeover:", error);
        });
    } catch (error) {
      set_loader(false);
      console.error("Unexpected error in handleSubmit:", error);
    }
  };

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <h3>Fuel Changeover Record</h3>
        <br />
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Completion (Low Sulphur)</label>
              <DatePicker
                showTime
                value={form.changeOverCompletion}
                onChange={(date) => handleChange("changeOverCompletion", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
              />
              {errors.date_and_time_completion || errors.changeOverCompletion ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_completion || errors.changeOverCompletion}
                </span>
              ) : null}
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (Completion)"
              value={form.shipPositionCompletion}
              onChange={(e) => handleChange("shipPositionCompletion", e.target.value)}
              errors={errors.ship_position || errors.shipPositionCompletion}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Completion (Tank ID/m3)"
              value={form.lowSulphurQtyAfter}
              onChange={(e) => handleChange("lowSulphurQtyAfter", e.target.value)}
              errors={errors.low_sulphur_quality_completion || errors.lowSulphurQtyAfter}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Entry into ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaEntry}
                onChange={(date) => handleChange("ecaEntry", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
              />
              {errors.date_and_time_entry_eca || errors.ecaEntry ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_entry_eca || errors.ecaEntry}
                </span>
              ) : null}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Exit from ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaExit}
                onChange={(date) => handleChange("ecaExit", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
              />
              {errors.date_and_time_exit_eca || errors.ecaExit ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_exit_eca || errors.ecaExit}
                </span>
              ) : null}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Changeover to High Sulphur</label>
              <DatePicker
                showTime
                value={form.changeOverToHighSulphur}
                onChange={(date) => handleChange("changeOverToHighSulphur", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
              />
              {errors.date_and_time_changeover_high_sulphur || errors.changeOverToHighSulphur ? (
                <span style={{ color: "red" }}>
                  {errors.date_and_time_changeover_high_sulphur || errors.changeOverToHighSulphur}
                </span>
              ) : null}
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (High Sulphur Start)"
              value={form.shipPositionHighSulphur}
              onChange={(e) => handleChange("shipPositionHighSulphur", e.target.value)}
              errors={errors.ship_position_high_sulphur || errors.shipPositionHighSulphur}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Start (Tank ID/m3)"
              value={form.lowSulphurQtyBefore}
              onChange={(e) => handleChange("lowSulphurQtyBefore", e.target.value)}
              errors={errors.low_sulphur_quality_start || errors.lowSulphurQtyBefore}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Remarks"
              value={form.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
            />
          </div>
          <div className="col-6">
            <AppInput
              label="Chief Eng. Name & Digital Signature"
              value={form.chiefEngSign}
              onChange={(e) => handleChange("chiefEngSign", e.target.value)}
              errors={errors.chief_eng_name_sign || errors.chiefEngSign}
            />
          </div>
        </div>

        <div className="input-box mt-3">
          <Button loading={loader} type="primary" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddFuelChangeover;
